<template>
  <div class="parent">
    <div class="textInput">
      <label v-if="Title" class="label" for="tbox1">{{ Title }}</label>
      <input
        class="input"
        :class="{ errorStyle: error }"
        type="number"
        id="tbox1"
        name="tbox1"
        :value="Value"
        min="1"
        @input="$emit('onChangeVal', handleEmit($event.target))"
        required
      /><br />
    </div>
  </div>
</template>

<script lang="ts">
export default {
  props: {
    Title: {
      type: String,
      default: ""
    },
    error: {
      type: String,
      default: ""
    },
    Value: {
      type: [String, Number],
      default: ""
    }
  },
  emits: ["onChangeVal"],
  methods: {
    handleEmit(target: EventTarget | null) {
      return (target as HTMLInputElement).value;
    }
  }
};
</script>

<style scoped>
.input {
  width: 250px;
  height: calc(1.4285714286em + 8px);
  border-color: rgba(0, 0, 0, 0.08);
  color: #424242;
  background-color: #ffffff;
  border-radius: 2px;
  text-align: right;
}
.label {
  font-size: 16px;
  width: 250px;
}
.counter {
  position: absolute;
  top: 41px;
  left: 254px;
  color: #767474;
  font-size: 12px;
}
.textInput {
  height: 57px;
}
.errorStyle {
  border-color: red;
}
</style>
>
